import { browserCookies } from '@gousto-internal/storage-consent-web-package'

export const persistenceConfig = (store) => {
  const [hasConsentedTrackingCookie] = browserCookies.getString('v1_goustoStateStore_tracking')

  let persistentCookies = {
    promoAgeVerified: false,
    variants: false,
    basket: {},
    menu: {},
    deliveryDetails: {},
    signup: {},
  }

  if (hasConsentedTrackingCookie) {
    persistentCookies.tracking = false
  }

  if (!store.basket.get('orderId')) {
    persistentCookies = Object.assign(persistentCookies, {
      /* one layer deep only, add the resulting cookie names
      to CookieGuard.php in underscore form */
      basket: {
        postcode: true,
        date: true,
        address: false,
        numPortions: true,
        slotId: true,
        recipes: false,
        previewOrderId: true,
        stepsOrder: false,
        collection: true,
        promoCode: true,
        subscriptionOption: true,
        recipePositions: false,
      },
      menu: {
        selectedRecipeVariants: false,
      },
      deliveryDetails: {
        deliveryInstruction: true,
        deliveryInstructionCustom: true,
      },
      signup: {
        signupMotivations: false,
      },
    })
  }

  return persistentCookies
}

export const cookiePrefix = 'goustoStateStore'

export const cookieExpiries = {
  default: 2 / 24,
  tracking: 30,
  basket_numPortions: 7,
  basket_postcode: 7,
  basket_promoCode: 60,
  menu_selectedRecipeVariants: 7,
  deliveryDetails_deliveryInstruction: 7,
  deliveryDetails_deliveryInstructionCustom: 7,
  signup_signupMotivations: 7,
}
